import * as jsxRuntime from "/home/ubuntu/bookmd/client/apps/eligibility/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment